// Catálogo de métodos de pagamento — o que dá para habilitar em uma loja ou
// white label.
//
// Antes cada tela mantinha sua constante: o merchant listava 5 itens (um deles,
// WALLET, sequer existe no enum do backend) e o white label listava 11. O
// catálogo real é a tabela `payment_method` do backoffice — método que não está
// lá dá 404 no add, porque o service resolve por findByName.
import { api } from "@/api"
import { BASE_URL, ENDPOINTS } from "@/constants"
import { useQuery } from "@/libs"
import type { PaymentMethodCatalogItem } from "@/types/payment-method-catalog"

export const PAYMENT_METHOD_CATALOG_QUERY_KEY =
  ENDPOINTS.PAYMENT_METHOD_CATALOG

/** GET /payment-methods — métodos ATIVOS do catálogo, ordenados pelo enum. */
export const getPaymentMethodCatalog = async (): Promise<
  PaymentMethodCatalogItem[]
> => {
  const { data } = await api.get<
    PaymentMethodCatalogItem[]
  >(`${BASE_URL}${ENDPOINTS.PAYMENT_METHOD_CATALOG}`)
  // Mesma armadilha do 204: `Array.isArray` cobre "", undefined e null.
  return Array.isArray(data) ? data : []
}

export const paymentMethodCatalogQueryOptions = () => ({
  queryKey: [PAYMENT_METHOD_CATALOG_QUERY_KEY] as const,
  queryFn: getPaymentMethodCatalog,
  // Catálogo muda raramente — cache curto evita refetch a cada aba aberta, mas
  // não o suficiente para esconder um método recém-ativado no backoffice.
  staleTime: 5 * 60 * 1000,
})

export const usePaymentMethodCatalog = () =>
  useQuery(paymentMethodCatalogQueryOptions())
